import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { AccountsView } from "src/components/views/erp/common/accounting/accounts/AccountsView.tsx";

export const Route = createFileRoute("/_authenticated/_shell/common/accounting/accounts")({
	staticData: { title: i18n.t("accounts"), legacyViewKey: "accountsPage" },
	component: RouteComponent,
});

function RouteComponent() {
	return <AccountsView />;
}
